import React from 'react';
import Icon from '../common/Icon';
import { icons } from '../../config/icons';
import { usePopupMenu } from '../../context/PopupMenuContext';

const PopupDropdownMenu = ({ menuItems = [] }) => {
    const { closePopupMenu } = usePopupMenu();

    return (
        <div className="popup-menu-content">
            {menuItems && menuItems.length > 0 ? (
                menuItems.map((item, index) => (
                    <button 
                        key={index} 
                        onClick={(e) => { 
                            if (item.onClick) {
                                item.onClick(e); 
                            }
                            closePopupMenu(); 
                        }}
                    >
                        {item.icon && <Icon icon={icons[item.icon] || item.icon} />} 
                        {item.label}
                    </button>
                ))
            ) : (
                <div style={{ padding: '8px 16px', fontSize: '13px', color: '#888' }}>No items added</div>
            )}
        </div>
    );
};

export default PopupDropdownMenu;
